const getComponentName = component => (
  component.displayName ||
  component.name
);

export default getComponentName;



// WEBPACK FOOTER //
// ./src/utils/getComponentName.js